export default "__VITE_ASSET__Dak8mKsG__"